import type { EstimateDetail, LineItem } from "@/interfaces/estimate-detail";

function includeLineItemInDiff(li: LineItem): boolean {
  return !li.deleted && !li.archived && !!li.uniqueId;
}

/** Map stable row id → displayed line item string (for Cat 3 wording diff). */
export function buildLineTextByUniqueIdMap(rooms: EstimateDetail[] | undefined): Map<string, string> {
  const map = new Map<string, string>();
  if (!rooms?.length) return map;
  for (const room of rooms) {
    for (const tuple of room.dataForUI.page.tuplesOutput) {
      for (const li of tuple.lineItems) {
        if (!includeLineItemInDiff(li)) continue;
        map.set(li.uniqueId, li.lineItem);
      }
    }
  }
  return map;
}

/** `uniqueId`s whose description string changed between before and after snapshots. */
export function uniqueIdsWithChangedLineText(before: Map<string, string>, after: Map<string, string>): string[] {
  const changed: string[] = [];
  for (const [uid, afterText] of after) {
    const beforeText = before.get(uid);
    if (beforeText !== undefined && beforeText !== afterText) {
      changed.push(uid);
    }
  }
  return changed;
}
